import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translationsJobWorkflowInputClearState } from 'reducers/translations/jobWorkflowInput/reducer'
import JobWorkflowInputList from './JobWorkflowInputList'
import JobWorkflowInputItem from './JobWorkflowInputItem'

function JobWorkflowInput(props) {
  const {
    translationsJobWorkflowInputClearState,
    match: {
      params: { id },
    },
  } = props
  const JobWorkflowInputContent = id
    ? JobWorkflowInputItem
    : JobWorkflowInputList

  useEffect(
    () => () => {
      translationsJobWorkflowInputClearState()
    },
    [],
  )

  return (
    <div className="content">
      <JobWorkflowInputContent {...props} />
    </div>
  )
}

JobWorkflowInput.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  translationsJobWorkflowInputClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  translationsJobWorkflowInputClearState,
})(JobWorkflowInput)
